// import { Navigate, Outlet } from "react-router-dom";
// import useAuth from "./useAuth";

// export default function RequireAuth() {
//     const { auth } = useAuth()

//     return (
//         auth?.token
//             ? <Outlet />
//             : <Navigate to="/" />
//     )
// }

import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "./useAuth";

import { Unauthorized } from "../components/UnauthorizedPage/Unauthorized";

const RequireAuth = ({ allowedRoles }: any) => {
    const { auth } = useAuth();

    const location = useLocation();

    return (
        allowedRoles?.includes(auth?.role)
            ? <Outlet />
        : auth?.admin_id
            ? <Unauthorized />
            : <Navigate to="/login" state={{ from: location }} replace />
    )
}

export default RequireAuth;